import { gql, useMutation } from '@apollo/client';

import { GET_CURRENT_SUBSCRIPTION } from 'src/hooks/subscriptions/get-current-subscription.hook';

import { GET_EMPLOYEES_WITHOUT_ACTIVE_WORKING_CONDITIONS } from './get-employees-without-active-working-conditions.hook';
import { GET_PUBLIC_EMPLOYEES_FOR_TABLE } from './get-public-employees.hook';

const CREATE_EMPLOYEE = gql`
  mutation createInternalMember($payload: CreateInternalMemberInput!) {
    createInternalMember(payload: $payload) {
      _id
    }
  }
`;

export const useCreateEmployee = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [createEmployee] = useMutation(CREATE_EMPLOYEE, {
    onCompleted: data => {
      if (onSuccess && data) {
        onSuccess();
      }
    },
    refetchQueries: [
      GET_PUBLIC_EMPLOYEES_FOR_TABLE,
      GET_CURRENT_SUBSCRIPTION,
      GET_EMPLOYEES_WITHOUT_ACTIVE_WORKING_CONDITIONS,
    ],
  });

  return { createEmployee };
};
